import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface Locale
{
    lang: string;
    data: Object;
}

@Injectable()
export class FuseTranslationLoaderService
{

    constructor(private translate: TranslateService)
    {}

    public loadTranslations(...args: Locale[]): void
    {
        const locales = [...args];

        locales.forEach((locale) => {
            // use setTranslation() with the third argument set to true
            // to append translations instead of replacing them
            this.translate.setTranslation(locale.lang, locale.data, true);
        });
    }

    public getLang() {
        switch (this.translate.currentLang) {
            case 'en':
                return 'en-US';
            case 'ru':
                return 'ru-RU';
            default:
                return 'en-US';
        }
    }

    public getDatePickerTranslation() {
        switch (this.translate.currentLang) {
            case 'en':
                return  {
                    cancelBtnLabel: 'Cancel',
                    setBtnLabel: 'Set',
                    rangeFromLabel: 'From',
                    rangeToLabel: 'To'
                };
            case 'ru':
                return  {
                    cancelBtnLabel: 'Отмена',
                    setBtnLabel: 'Выбрать',
                    rangeFromLabel: 'От',
                    rangeToLabel: 'До'
                };
            default:
                return  {
                    cancelBtnLabel: 'Cancel',
                    setBtnLabel: 'Set',
                    rangeFromLabel: 'From',
                    rangeToLabel: 'To'
                };
        }
        
    }
}



// WEBPACK FOOTER //
// ./src/@fuse/services/translation-loader.service.ts